import { LegacyAudioChatSnapshot, ResumeIntakeState } from "../_types/resumeIntake";

const uniqueValues = (values: string[]) =>
  Array.from(new Set(values.map((value) => value.trim()).filter(Boolean)));

export const createResumeIntakeSnapshot = (
  snapshot: LegacyAudioChatSnapshot,
): ResumeIntakeState => {
  const suggestedSkills = uniqueValues(snapshot.jobAnalysis.parsedSkills);
  const selectedSkills = uniqueValues(snapshot.selectedSkills);

  return {
    step: "job",
    jobDescription: snapshot.jobDescription,
    jobAnalysis: snapshot.jobAnalysis,
    basics: {
      ...snapshot.personalInfo,
      headline: "",
      location: "",
    },
    experience: snapshot.workExpInfo.map((experience) => ({
      company: experience.jobCompanyName,
      position: experience.jobtitleAndResp,
      location: "",
      date: experience.jobDuration,
      rawResponsibilities: experience.jobtitleAndResp,
      suggestedBullets: experience.aiSugg,
      selectedBullets: uniqueValues([experience.jobUniqueImpact]),
      customSummary: experience.jobUniqueImpact,
    })),
    skills: {
      suggested: suggestedSkills,
      selected: selectedSkills,
      custom: selectedSkills.filter((skill) => !suggestedSkills.includes(skill)),
    },
    education: snapshot.educationInfo.map((education) => ({
      institution: education.institute,
      studyType: education.degree,
      area: education.major,
      date: education.duration,
      score: "",
      summary: "",
    })),
    extras: {
      awards: uniqueValues(snapshot.awardsInfo),
      certifications: uniqueValues(snapshot.certificationInfo),
      languages: uniqueValues(snapshot.languagesInfo),
      interests: uniqueValues(snapshot.hobbiesInfo),
    },
    summary: snapshot.userSummary,
    template: snapshot.currentTemplate,
  };
};
